module.exports = __webpack_public_path__ + "img/transmitter.6a54af22.png";